function Footer({ description, title }) {
    return (
        <footer className="py-10 text-center">
            <div className="mx-auto max-w-6xl px-4 sm:px-6">
                {title ? <h2 className="font-display text-lg font-extrabold">{title}</h2> : null}
                {description ? <p className="mt-2 text-sm text-slate-500">{description}</p> : null}
                <p className="text-sm text-current/80">
                    Copyright &copy;{' '}
                    <a href="https://unsam.ac.id/" className="font-bold text-current underline-offset-4 hover:underline">
                        UPT TIK
                    </a>{' '}
                    UNIVERSITAS SAMUDRA {new Date().getFullYear()}.
                </p>
            </div>
        </footer>
    );
}

export default Footer;
